import { useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import './MoodPage.css';
import AuthModal from '../components/AuthModal';

// פונקציה ליצירת JWT
function createJwt(user) {
  if (!user || !user.name || !user.email) return '';
  const header = { alg: 'none', typ: 'JWT' };
  const payload = { name: user.name, email: user.email };
  function base64url(obj) {
    const utf8 = encodeURIComponent(JSON.stringify(obj)).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode('0x' + p1);
    });
    return btoa(utf8).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  }
  return base64url(header) + '.' + base64url(payload) + '.';
}

const MoodPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  const [showAuth, setShowAuth] = useState(false);
  const [hasNavigated, setHasNavigated] = useState(false);

  // יצירת JWT פעם אחת בלבד
  const jwtToken = useMemo(() => {
    return location.state?.jwtToken || (user ? createJwt(user) : '');
  }, [location.state?.jwtToken, user]);

  useEffect(() => {
    // אם אין משתמש - הצג מודל התחברות
    if (!user || !user.name || !user.email) {
      setShowAuth(true);
      return;
    }

    // אם אין JWT ב-state ועוד לא ניווטנו - נווט פעם אחת
    if (!location.state?.jwtToken && !hasNavigated && jwtToken) {
      setHasNavigated(true);
      navigate('/mood', { state: { jwtToken }, replace: true });
    }
  }, [user, location.state?.jwtToken, navigate, jwtToken, hasNavigated]);

  // אם אין JWT - הצג טעינה
  if (!jwtToken) {
    return (
      <>
        <div style={{ 
          minHeight: '60vh', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          fontSize: '1.2rem',
          color: '#00994C'
        }}>
          טוען...
        </div>
        {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
      </>
    );
  }

  return (
    <div className="mood-page-container">
      <div className="mood-iframe-wrapper">
        <iframe
          src={`https://cazoty-mood.lovable.app/?token=${jwtToken}`}
          className="mood-iframe"
          title="מד מצב רוח"
          allowFullScreen
        />
      </div>
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </div>
  );
};

export default MoodPage;